
import BackgroundVideo from '../../src/modules/BackgroundVideo';
import BackgroundImage from '../../src/modules/BackgroundImage';

customElements.define(

  "cc-section-hero", 

  class extends HTMLElement{

        connectedCallback(){

            let xalign = this.getAttribute("xalign");
            let yalign = this.getAttribute("yalign");
            const videoURL = this.getAttribute("video");
            const imageURL = this.getAttribute("image");
            const element = this.innerHTML;
            let position = "";

            if( xalign == "" || !xalign){
                xalign = "center";
            }
            if( yalign == "" || !yalign){
                yalign = "flex-end";
            }
            position = `style="justify-content:${xalign};align-items:${yalign};"`;

            this.innerHTML = `
            <section id="cc-custom-section-hero">

                <div class="media image">

                </div>
                <div class="media video">

                </div>
                <div class="media foreground">

                    <div id="content-wrapper">

                        <div id="content" ${position}>
                            ${element}
                        </div>

                    </div>

                </div>

            </section>      

            `;

            let videoContainer = this.querySelector(".video");

            let imageContainer = this.querySelector(".image");

            if (videoContainer && videoURL != "" && videoURL ) { 

                new BackgroundVideo(videoURL, videoContainer)

            }
            if (imageContainer && imageURL != "" && imageURL) { 

                new BackgroundImage(imageURL, imageContainer);

            }

        }
       
    }

);